import { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import moment from 'moment';
import { setScanMode, getMachineConfig } from '../../../../actions/saActions';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Box, Button, MenuItem, Select } from "@material-ui/core";
import Popover from '@material-ui/core/Popover';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../../reducers/uiSlice';
import { useToken } from '../../../../utilities/hooks';

const useStyles = makeStyles((theme)=> ({
    popover: {
        pointerEvents: 'none'
    },
    infoDetails: {
        marginTop: 5,
        border: '1px solid rgba(255, 255, 255, 0.5)',
        width: 340,
        borderRadius: 5,
        padding: 5
    },
    infoLineBatches: {
        padding: 4,
        display: 'flex'
    },
    infoLine: {
        padding: 4,
    },
    batchStyle: {
        width: 240,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: '1.3'
    }
}))

const HeightSelect = withStyles((theme) => ({
    root: {
        padding: '5px'
    },
}))(Select);

function BasicInfo(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('slotAssignment');

    const tokenContents = useToken();
    const userUS = tokenContents.userUS;

    const [branch, setBranch] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const [mappingId, setMappingId] = useState('');
    const [scanLocation, setScanLocation] = useState('');
    const [machineCode, setMachineCode] = useState('');
    const [mode, setMode] = useState('');
    const [modeCode, setModeCode] = useState('');
    const [batchInfo, setBatchInfo] = useState('');
    const [lastModified, setLastModified] = useState('');
    const [targetMode, setTargetMode] = useState('');
    const [targetModeCode, setTargetModeCode] = useState('');
    const [sortingActionCode, setSortingActionCode] = useState(0);

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };
    const handleModeChange = (event) => {
        setMode(event.target.value);
        if(event.target.value === 'BLIND_SCAN_MODE') {
            setModeCode(100);
            setTargetMode('GATEWAY_TRANSIT');
            setTargetModeCode(199);
            setSortingActionCode(0);
        } else if(event.target.value === 'NORMAL_SCAN_MODE') {
            setModeCode(110);     
            setSortingActionCode(0);       
        } else if(event.target.value === 'SMART_SCAN_MODE') {
            setModeCode(120);            
        }
    }
    const handleTargetModeChange = (event) => {
        setTargetMode(event.target.value);
        if(event.target.value === 'GATEWAY_TRANSIT') {
            setTargetModeCode(199);
        } else if(event.target.value === 'PARCEL_SCANNED') {
            setTargetModeCode(200);
        } else if(event.target.value === 'PARCEL_SCANNED') {
            setTargetModeCode(195);
        }
    }
    const handleSortingActionChange = (event) => {
        setSortingActionCode(event.target.value);
    }

    const open = Boolean(anchorEl);

    useEffect(() => {
        if(props.machineConfig) {
            if(props.machineConfig[0]) {
                setBranch(props.machineConfig[0].warehouse);
                setMappingId(props.machineConfig[0].id)
                setScanLocation(props.machineConfig[0].scan_location);
                setMachineCode(props.machineConfig[0].machine_code);
                setMode(props.machineConfig[0].mode);
                setModeCode(props.machineConfig[0].mode_code);
                setTargetMode(props.machineConfig[0].target_state);
                setTargetModeCode(props.machineConfig[0].target_state_code);
                setBatchInfo(props.machineConfig[0].scan_batch);
                setSortingActionCode(props.machineConfig[0].smart_sorting_action);
                const dateNum = props.machineConfig[0].last_modified;
                setLastModified(moment.unix(dateNum).format("YYYY-MM-DD, HH:mm:ss"));
            }
        }       
    }, [props.machineConfig])
    useEffect(() => {
        if(props.machineConfig) {
            if(props.machineConfig.length > 0) {
                props.machineConfig.map((config) => {
                    if(config.machine_code === machineCode) {
                        setBranch(config.warehouse);
                        setMappingId(config.id)
                        setScanLocation(config.scan_location);
                        setMachineCode(config.machine_code);
                        setMode(config.mode);
                        setModeCode(config.mode_code);
                        setTargetMode(config.target_state);
                        setTargetModeCode(config.target_state_code);
                        setSortingActionCode(config.smart_sorting_action);
                        setBatchInfo(config.scan_batch);
                        const dateNum = config.last_modified;
                        setLastModified(moment.unix(dateNum).format("YYYY-MM-DD, HH:mm:ss"));
                    }
                })
            }
        }
    }, [machineCode])

    return (
        <Box color="text.primary">
            <div>{t('sort_machine_config')}</div>
            <div className={classes.infoDetails}>
                <div className={classes.infoLine}>
                    <span>{t('warehouse')}</span>
                    <span>{scanLocation}</span>
                </div>
                <div className={classes.infoLine}>
                    <span>{t('machine_code')}</span>
                    <HeightSelect
                        displayEmpty
                        variant="outlined"
                        size='small'
                        value={machineCode}
                        onChange={(event) => {
                            setMachineCode(event.target.value)
                        }}
                    >
                        {
                            props.machineConfig &&
                            props.machineConfig.length > 0 &&
                            props.machineConfig.map((config) => {
                                return(
                                    <MenuItem
                                        key={config}
                                        value={config.machine_code}
                                    >
                                        {config.machine_code}
                                    </MenuItem>
                                )
                            })
                        }
                    </HeightSelect>
                </div>
                <div className={classes.infoLine}>
                    <span>{t('mode')}</span>
                    <HeightSelect
                        value={mode || 'BLIND_SCAN_MODE'}
                        displayEmpty
                        variant="outlined"
                        size='small'
                        onChange={handleModeChange}
                    >
                        <MenuItem key={0} value='BLIND_SCAN_MODE'>{t('blind_scan_mode')}</MenuItem>
                        <MenuItem key={1} value='NORMAL_SCAN_MODE'>{t('normal_scan_mode')}</MenuItem>
                        <MenuItem key={2} value='SMART_SCAN_MODE'>{t('smart_scan_mode')}</MenuItem>
                    </HeightSelect>                    
                </div>
                <div className={classes.infoLine}>
                    <span>{t('mode_code')}</span>
                    <span>{modeCode}</span>
                </div>
                {/* Only apply target mode to VANCOUVER */}
                {
                    (branch === 1 || branch === 2 || branch === 5 || userUS) && <div className={classes.infoLine}>
                        <span>{t('target_mode')}</span>
                        <HeightSelect
                            value={targetMode}
                            displayEmpty
                            variant="outlined"
                            size='small'
                            onChange={handleTargetModeChange}
                            disabled={modeCode === 100}
                        >
                            <MenuItem key={0} value='GATEWAY_TRANSIT'>{t('orderStatus:GATEWAY_TRANSIT')}</MenuItem>
                            <MenuItem key={1} value='PARCEL_SCANNED'>{t('orderStatus:PARCEL_SCANNED')}</MenuItem>
                            <MenuItem 
                                key={2} 
                                value='GATEWAY_TRANSIT_OUT'
                                disabled={modeCode !== 120}
                            >
                                {t('orderStatus:195')}
                            </MenuItem>
                        </HeightSelect>                    
                    </div>                
                }
                {
                    (branch === 1 || branch === 2 || branch === 5 || userUS) && <div className={classes.infoLine}>
                        <span>{t('target_mode_code')}</span>
                        {
                            targetModeCode !== 0 && <span>{targetModeCode}</span>
                        }
                    </div>
                }               
                <div className={classes.infoLine}>
                    <span>{t('sorting_action')}</span>
                    <HeightSelect
                        value={sortingActionCode}
                        displayEmpty
                        variant="outlined"
                        size='small'
                        onChange={handleSortingActionChange}
                        disabled={modeCode!==120}
                    >
                        <MenuItem key={1} value={1}>{t('sorting_segment')}</MenuItem>
                        <MenuItem key={2} value={2}>{t('sorting_route')}</MenuItem>
                    </HeightSelect>                    
                </div>         
                <div className={classes.infoLineBatches}>
                    <span>{t('batch_info')}</span>
                    <span>{batchInfo}</span>
                    <Popover
                        id="mouse-over-popover"
                        className={classes.popover}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                        }}
                        transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                    </Popover>                            
                </div>
                <div className={classes.infoLine}>
                    <span>{t('lastModified')}</span>
                    <span>{lastModified}</span>
                </div>
                <div style={{ textAlign: "right", padding: 5 }}>
                    <Button variant="contained" color="primary" onClick={handleModify}>{t('modify')}</Button>
                </div>
            </div> 
        </Box>
    );

    function handleModify() {
        let params = {
            warehouse: branch,
            machine_code: machineCode,
            mode_code: modeCode,
            target_state: targetModeCode
        }
        if(modeCode === 120) {
            params['smart_sorting_action'] = sortingActionCode;
            params['smart_action_name'] = sortingActionCode === 1 ? 'SORTING_ZONE' : 'SMART_ACTION_SORTING_ROUTE';
        }
        dispatch(setScanMode(params))
        .then(() => {
            dispatch(getMachineConfig(branch));
            dispatch(showAlertSnackbar({message:t('config_success'),type:'success'}))
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message:t('config_fail'),type:'error'}))
        })
    }
}

export default BasicInfo;
